module.exports = __webpack_public_path__ + "static/media/Increase_bg.0bf883ce.png";